<template>
  <router-link
    :to="{
      name: 'kids',
      params,
    }"
    class="wrapper-item"
    :class="`${alignStart ? 'align-items-start' : 'align-items-center'}`"
  >
    <div
      v-if="!hiddeImage"
      class="item-shape"
      :class="{
        'mb-3': !hiddeInfos,
      }"
      :style="{
        background: `url(${backgroundUrl}), #333`,
        'background-size': 'cover',
      }"
    >
      <div v-if="!isInPlan" class="locked">
        <img src="@/assets/images/lock-red.svg" alt="Bloqueado" />
      </div>
    </div>

    <div v-if="!hiddeInfos">
      <div class="name mb-1">
        {{ item.serie }}
      </div>
    </div>
  </router-link>
</template>

<script>
  import get from "lodash/get";

  export default {
    props: {
      item: {
        type: Object,
        required: true,
      },
      hiddeInfos: {
        type: Boolean,
        required: false,
        default: false,
      },
      hiddeImage: {
        type: Boolean,
        required: false,
        default: false,
      },
      alignStart: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
      backgroundUrl() {
        return this.item?.cover || (this.item.book && this.item.book.cover);
      },
      params() {
        return { id: get(this.item, "book.id", this.item.id) };
      },
      isInPlan() {
        const currentSignature =
          this.$store.state.user &&
          this.$store.state.user.user.current_signature
            ? this.$store.state.user.user.current_signature.id
            : 1;
        return this.item.signatures.includes(currentSignature);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .wrapper-item {
    .item-shape {
      width: 100%;
      border-radius: 10px;
      aspect-ratio: 420/230;
      min-height: 1px;

      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    .name {
      font-family: "Inter";
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 17px;
      text-transform: uppercase;

      color: #767676;
    }

    .locked {
      position: absolute;
      right: 8px;
      top: 8px;
    }
  }
</style>
